<template>
  <div>
    <title>酒旅产品基本信息</title>
    <!--S 公用头部切换-->
    <TravelInfoTab :active="currentTit"></TravelInfoTab>
    <!--E 公用头部切换-->

    <!-- S 基础详情表单组件 -->
    <GoodsInfoPage :goodsType="3"></GoodsInfoPage>
    <!-- E 基础详情表单组件 -->
    
  </div>
</template>
<script>

export default {
  name: 'travelBasicInfo',
  data () {
    return {
      currentTit:0, //当前选中菜单
    }
  },
  filters: {

  },
  components: {
    TravelInfoTab: resolve => require(["@/components/GoodsFolder/TravelInfoTab.vue"],resolve), //头部tab组件
    GoodsInfoPage: resolve => require(["@/components/common/GoodsInfoPage.vue"],resolve), //基础详情表单组件
  },
  methods: {
    
  },
  created() {
    
  },
  mounted () {

  },
  computed: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/Travel/TravelBasicInfo.vue